module.exports = __webpack_public_path__ + "static/college-grad-mobile.40143cd2.webp";